import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const UpdateFinishBonus = ({ 
  formData, 
  handleChange, 
  handleBonusChange,
  handleAddBonus,
  handleRemoveBonus,
  handleSubmit, 
  loading, 
  onCancel,
  error 
}) => {
  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Finish Bonus</h2>

      {loading && <p className="text-blue-500 mb-4">Updating...</p>}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Header Title</label>
          <input
            type="text"
            name="header_title"
            value={formData.header_title}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter header title"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Header Icon</label>
          <input
            type="text"
            name="header_icon"
            value={formData.header_icon}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter header icon (e.g., fas fa-gift)"
            required
          />
        </div>

        <div className="border-t pt-4 mt-4">
          <h3 className="text-lg font-semibold mb-3">Bonuses</h3>
          
          {formData.bonuses.map((bonus, index) => (
            <div key={index} className="mb-4 p-3 border rounded bg-gray-50 space-y-3">
              <div className="flex justify-between items-center">
                <h4 className="font-medium">Bonus #{index + 1}</h4>
                {formData.bonuses.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveBonus(index)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Remove
                  </button>
                )}
              </div>

              <div>
                <label className="block text-gray-700 font-medium">Icon</label>
                <input
                  type="text"
                  name="icon"
                  value={bonus.icon}
                  onChange={(e) => handleBonusChange(index, e)}
                  className="border w-full p-2"
                  placeholder="Enter icon (e.g., fas fa-check)"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">Title</label>
                <input
                  type="text"
                  name="title"
                  value={bonus.title}
                  onChange={(e) => handleBonusChange(index, e)}
                  className="border w-full p-2"
                  placeholder="Enter title"
                  required
                />
              </div>

              <div>
                <label className="block text-gray-700 font-medium">Description</label>
                <ReactQuill
                  value={bonus.description}
                  onChange={(content) => {
                    const e = { target: { name: "description", value: content } };
                    handleBonusChange(index, e);
                  }}
                  className="border w-full p-2"
                />
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={handleAddBonus}
            className="px-4 py-2 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
          >
            Add Another Bonus
          </button>
        </div>

         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Finish Bonus"}
            </button>
        </div>

       
      </form>
    </div>
  );
};

export default UpdateFinishBonus;